export default {
  ticketNumber: 'Ticket Nro. ',
  creationDate: 'Fecha de ingreso: ',
  deadlineDate: 'Plazo máximo de término: ',
  finishDate: 'Fecha de finalización: '
}
